// extracted by mini-css-extract-plugin
export default {"root":"PeerColorWrapper-module__root"};